<a class="item" routerLink="/" routerLinkActive="active">
    <mat-icon class="material-icons-outlined">home</mat-icon>Home
</a>

<a class="item" routerLink="/initiateHandover" routerLinkActive="active">
    <mat-icon class="material-icons-outlined">search</mat-icon>Buscar pozos
</a>